import { baasProxy } from "./baasConsoleClient";

export const fetchBaasProviderPaySmartConfig = (instance) =>
  baasProxy({
    instance,
    method: "GET",
    baasPath: "v1/console/paysmart/config",
  });

export const fetchBaasProviderPixLimit = (instance) =>
  baasProxy({
    instance,
    method: "GET",
    baasPath: "v1/console/paysmart/pix-provider-limit",
  });

export const updateBaasProviderPixSpiLimit = (instance, spiMaxPerOperationAmount) =>
  baasProxy({
    instance,
    method: "PUT",
    baasPath: "v1/console/paysmart/pix-provider-limit",
    body: { spi_max_per_operation_amount: spiMaxPerOperationAmount },
  });

export const updateBaasProviderPixOutboundRules = (instance, rules) =>
  baasProxy({
    instance,
    method: "PUT",
    baasPath: "v1/console/paysmart/pix-outbound-rules",
    body: { rules },
  });

export const fetchBaasPartnerHttpLogs = (instance, query = {}) =>
  baasProxy({
    instance,
    method: "GET",
    baasPath: "v1/console/partner-http-logs",
    query,
  });

export const fetchBaasInboundWebhookLogs = (instance, query = {}) =>
  baasProxy({
    instance,
    method: "GET",
    baasPath: "v1/console/inbound-webhook-logs",
    query,
  });

export const fetchBaasInboundWebhookLogDetail = (instance, id) =>
  baasProxy({
    instance,
    method: "GET",
    baasPath: `v1/console/inbound-webhook-logs/${encodeURIComponent(id)}`,
  });
